import { Control, ControllerValidatedSelect, MenuItem } from '@bymason-private/legacy-pattern-components';
import { Fields, QRCodeFormModel } from '../types';
import { sortedTimezones } from './timezones';

export function TimeZoneSelect({ control }: { control: Control<QRCodeFormModel> }) {
  return (
    <ControllerValidatedSelect
      name={Fields.TimeZone}
      fullWidth
      label='Time zone'
      required
      control={control}
      helperText='Set time zone for devices without a SIM card'
    >
      {sortedTimezones.map((tz) => (
        <MenuItem key={tz.tzCode} value={tz.tzCode}>
          {tz.label}
        </MenuItem>
      ))}
    </ControllerValidatedSelect>
  );
}
